import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    container: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius * 2,
        paddingInline: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 55,
        [theme.breakpoints.down("md")]: {
            paddingBlock: theme.spacing(2),
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            "& > :nth-child(2)": {
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(6),
            },
        },
    },
    iconTextContainer: {
        display: "flex",
        alignItems: "center",
    },
    icon: {
        display: "flex",
        alignItems: "center",
        color: theme.palette.primary.main,
        marginRight: theme.spacing(2),
        "& svg": {
            width: 34,
            height: 34,
        },
    },
}));
